import {UserRole} from "../../../authentication/authenticated-user";
import {HomeMeasurementStatus} from "../../found-measurement";

export function canMailDevice(role: UserRole, homeStatus: HomeMeasurementStatus | undefined): boolean {
  return role === "HMO" && homeStatus! === "MAILING_TO_PATIENT";
}
